import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOForWebsiteProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
  twitterCard?: string;
  canonical?: string;
}

const SEOForWebsite: React.FC<SEOForWebsiteProps> = ({
  title = 'ImpactQuill - Email Deliverability Solutions',
  description = 'Expert email deliverability solutions for businesses of all sizes. Protect your domain reputation, boost deliverability, and transform your email marketing.',
  keywords = 'email deliverability, email marketing, domain reputation, email audit, SPF, DKIM, DMARC',
  ogImage = '/images/og-image.jpg',
  ogType = 'website',
  twitterCard = 'summary_large_image',
  canonical
}) => {
  const siteUrl = 'https://impactquill.com';
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : siteUrl;
  const fullTitle = title.includes('ImpactQuill') ? title : `${title} | ImpactQuill`;

  useEffect(() => {
    // Debug log to verify the title is being set
    console.log('Setting title to:', fullTitle);
  }, [fullTitle]);

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullCanonical} />

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:image" content={`${siteUrl}${ogImage}`} />
      <meta property="og:site_name" content="ImpactQuill" />

      {/* Twitter Meta Tags */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${siteUrl}${ogImage}`} />

      {/* Additional Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="ImpactQuill" />
    </Helmet>
  );
};

export default SEOForWebsite; 